// @flow @jsx h

/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import coreInput from '@nrk/core-input'
import { Component, h } from 'preact'

import styles from './index.css'

type Props = {
  ajax: string,
  value: string | null,
  onSelect: (value: string | null, name: string | null) => void
}

type State = {
  q: string
  // loading: boolean,
  // focused: boolean
}

class SuggestSearch extends Component<Props, State> {
  elm: HTMLDivElement
  xhr: XMLHttpRequest | null

  constructor (props: Props) {
    super()
    this.state = {
      q: props.value || ''
      // loading: false,
      // focused: false
    }
  }

  componentDidMount () {
    const inputElm: any = this.elm.firstElementChild

    if (!inputElm) {
      console.warn('Could not find input element')
      return
    }

    this.elm.addEventListener('input.filter', this.handleFilter)
    this.elm.addEventListener('input.select', this.handleSelect)
    this.elm.addEventListener('input.ajax', this.handleAjax)

    const coreInputOpts = {
      open: false,
      content: null,
      ajax: this.props.ajax
    }

    coreInput(inputElm, coreInputOpts)

    if (this.props.value) {
      inputElm.value = this.props.value
    }
  }

  handleFilter = (evt: any) => {
    evt.preventDefault()

    const { target } = evt

    if (target) {
      this.search(target.value)
    }
  }

  handleSelect = (evt: any) => {
    const name = evt.detail.value
    const btnEl = this.elm.querySelector(`button[value="${name}"]`)

    if (btnEl) {
      const id = btnEl.getAttribute('data-id')
      this.props.onSelect(id || null, name)
    }
  }

  handleAjax = (evt: any) => {
    const items = evt.detail.responseJSON

    coreInput(
      evt.target,
      items.length
        ? items
          .map(
            item =>
              `<li><button type="button" data-id=${item.id} value="${
                item.name
              }">${coreInput.highlight(
                item.name,
                evt.target.value
              )}</button></li>`
          )
          .join('')
        : '<li><button type="button">No results</button></li>'
    )
  }

  search (q: string) {
    this.setState({ q })

    if (this.xhr) {
      // console.log('abort')
      this.xhr.abort()
    }

    const xhr = new XMLHttpRequest()
    const url = this.props.ajax.replace('{{value}}', q)

    this.xhr = xhr

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        try {
          const items = JSON.parse(xhr.responseText)
          this.populate(items)
        } catch (_) {
          // ignore
        }
        this.xhr = null
      }
    }

    xhr.open('GET', url)

    xhr.send()
  }

  populate (items: any) {
    coreInput(
      this.elm.firstElementChild,
      items.length
        ? items
          .slice(0, 5)
          .map(
            item =>
              `<li><button type="button" data-id=${item.id} value="${
                item.name
              }">${coreInput.highlight(
                item.name,
                this.state.q
              )}</button></li>`
          )
          .join('')
        : '<li><button type="button">No results</button></li>'
    )
  }

  render () {
    return (
      <div class={styles.suggestSearch}>
        <label for='dh-skogbrann-suggest-search'>Finn din kommune</label>
        <div class={styles.suggestSearch__input} ref={elm => (this.elm = elm)}>
          <input
            type='text'
            name='q'
            placeholder='Søk'
            autoComplete='off'
            id='dh-skogbrann-suggest-search'
          />
          <ul hidden />
        </div>
        <svg viewBox='0 0 30 30'>
          <use xlinkHref='#nrk-search' />
        </svg>
      </div>
    )
  }
}

export default SuggestSearch



// WEBPACK FOOTER //
// ./src/v1/components/SuggestSearch/index.js